// extracted by mini-css-extract-plugin
module.exports = {"gridRow":"styles_gridRow__3DCL2","dropdown":"styles_dropdown__3QNOM","small":"styles_small__gb2IC","subtitle":"styles_subtitle__1sPvd","value":"styles_value__368m9"};